import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleUpMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-up-medium, dropdown, caret"><path d="M10.6603 8.4287C11.3596 7.59664 12.6406 7.59673 13.34 8.4287L16.4445 12.124C17.4007 13.2624 16.5912 14.9996 15.1046 15H8.89563C7.40917 14.9995 6.59964 13.2624 7.55579 12.124L10.6603 8.4287Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronTriangleUpMedium;
